module.exports = __webpack_public_path__ + "static/media/dinein-white.f00036f5.svg";